<div class="profile-block">
  @if (!user) {
    <a [href]="loginLink" class="button login-button with-line" dataTest="btn-login">
      <outlaw-icon class="icon" name="majiSign" />
      <span class="name">Login</span>
    </a>
  }

  @if (user) {
    <div class="profile">
      <button
        type="button"
        class="profile-info"
        [class.is-open]="showUserMenu"
        (click)="toggleMenu($event)"
        dataTest="btn-profile"
      >
        <div class="user-info">
          <div class="avatar">
            <img
              [src]="user.avatar_url || defaultAvatar"
              [alt]="user.username + ' avatar'"
              class="img"
              (error)="onAvatarError($event)"
            />
          </div>
          <span class="username">{{ user.username }}</span>
        </div>
        @if (menuItems.length) {
          <span class="drop-down-btn" [ngClass]="dropdownIconClass">
            <outlaw-icon class="icon" size="8px" name="dropDown" />
          </span>
        }
      </button>
      @if (showUserMenu) {
        <div class="profile-menu" [ngClass]="menuDirection">
          @for (item of menuItems; track item) {
            <button class="item" (click)="handleItemClick(item)" [dataTest]="item.dataTest">
              {{ item.label }}
            </button>
          }
        </div>
      }
    </div>
  }
</div>
